export default __webpack_public_path__ + "static/media/we-are-searching.8bb512ba.svg";